<template>
  <div>
    <v-card class="mt-2">
      <v-card-title class="headline"
        >Nutrition Block History
        <v-spacer />
        <v-btn @click="modal.create = true" color="primary" outlined>
          Assign Block
        </v-btn>
      </v-card-title>
      <v-skeleton-loader v-if="$apollo.loading" type="table" />
      <div v-else>
        <v-card-text v-if="nutritionSubscriptionBlocks.edges.length == 0">No Block slected</v-card-text>
        <div v-for="subscription in nutritionSubscriptionBlocks.edges" :key="subscription.node.id">
          <v-card-text class="d-flex justify-space-between">
            <div>{{ subscription.node.nutritionBlock.title }}</div>
          </v-card-text>
          <v-card-text class="d-flex justify-space-between">
            <div>Start Date</div>
            <div>{{ subscription.node.startDate }}</div>
            <v-btn
              :disabled="!subscription.node.active"
              class="mx-2"
              icon
              @click="handleEdit(subscription.node.id)"
              color="primary"
              outlined
              small
            >
              <v-icon color="secondary">create</v-icon></v-btn
            >
          </v-card-text>
        </div>
      </div>
    </v-card>
    <v-dialog v-model="modal.create" width="900" transition="dialog-bottom-transition" class="limited-height">
      <manage-nutrition-block :userId="userId" @close="modal.create = false" />
    </v-dialog>
    <v-dialog
      v-if="modal.edit"
      v-model="modal.edit"
      width="900"
      transition="dialog-bottom-transition"
      class="limited-height"
    >
      <manage-nutrition-block
        :subscriptionBlockId="this.selectedSubscriptionBlockId"
        mode="EDIT"
        :userId="userId"
        @close="modal.edit = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { SUBSCRIPTION_ACTIVITY_QUERY } from "@/constants/graphql/coach/coaching";
import ManageNutritionBlock from "@/components/nutrition/ManageNutritionBlock";

export default {
  name: "NutritionBlockHistory",
  components: {
    ManageNutritionBlock,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      nutritionSubscriptionBlocks: null,
      modal: {
        create: false,
        edit: false,
      },
    };
  },
  methods: {
    handleEdit(id) {
      this.selectedSubscriptionBlockId = id;
      this.modal.edit = true;
    },
  },
  apollo: {
    nutritionSubscriptionBlocks: {
      query: SUBSCRIPTION_ACTIVITY_QUERY,
      fetchPolicy: "cache-and-network",
      variables() {
        let encoded_json_payload = btoa("UserNode:" + this.userId);
        return {
          userId: encoded_json_payload,
        };
      },
    },
  },
};
</script>
